import { Nav } from '@accedo/spatial-nav';
import { FunctionalComponent } from 'preact';
import { stylesheet } from 'astroturf';
import clsx from 'clsx';

import SearchIcon from '##/assets/icons/Nav-Icon-Search.svg';
import { SEARCH_LANDING_BAR_ID } from '##/utils';

const styles = stylesheet`
  @import '##/styles/import.scss';

  .search-bar {
    width: 45vw;
    background: $pure-white-10;
    border-radius: pxToVw(25);
    margin-bottom: 1vh;
    margin-left: pxToVw(16);
    padding: pxToVw(12);
    color: $search-font-grey;
    line-height: pxToVh(25);
    font-size: 2rem;
    display: flex;
    align-items: center;
    font-family: barlow;

    &:global(.current-focus) {
      background: $pure-white;
    }
  }

  .search-bar-icon {
    fill: $search-font-grey;
    height: pxToVh(20);
    margin-left: pxToVw(10);
 

  }
`;
export const SearchLandingBar: FunctionalComponent<{
  onSelected: () => void;
  searchTerm: string;
}> = ({ onSelected, searchTerm }) => (
  <Nav.Focusable id={SEARCH_LANDING_BAR_ID} onSelect={onSelected}>
    <div className={clsx(styles.searchBar)}>
      <SearchIcon className={styles.searchBarIcon} />
      {searchTerm}
    </div>
  </Nav.Focusable>
);
